import type React from "react";
import { ReactComponent as Svg } from "./assets/bet-quaddie.svg";
import * as styles from "./Icon.module.scss";

type BetQuaddieProps = React.SVGProps<SVGSVGElement>;

export const BetQuaddie = ({ className, ...props }: BetQuaddieProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
